import { createFileRoute } from "@tanstack/react-router";

import { AppShell } from "@/components/app/app-shell";
import { InterestList } from "@/components/app/interest-list";

export const Route = createFileRoute("/_authenticated/t1dwpanel/notify-list")({
  head: () => ({
    meta: [
      { title: "Notify list | Warrior Volunteer" },
      { name: "description", content: "People who asked to hear about future T1D Warriors volunteer opportunities." },
      { property: "og:title", content: "Notify list | Warrior Volunteer" },
      { property: "og:description", content: "People who asked to hear about future T1D Warriors volunteer opportunities." },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: NotifyListPage,
});

function NotifyListPage() {
  return (
    <AppShell title="Notify list" eyebrow="Admin">
      <InterestList />
    </AppShell>
  );
}
